import { lazy, Suspense } from "react";
import { MobileGate } from "./components/MobileGate.jsx";
import { useDesktopViewport } from "./app/useDesktopViewport.js";

const DesktopApplication = lazy(() => import("./app/DesktopApplication.jsx"));

export default function App() {
  const isDesktop = useDesktopViewport();
  if (!isDesktop) return <MobileGate />;
  return <Suspense fallback={<div className="desktop-entry-loading" role="status">正在加载电脑版…</div>}><DesktopApplication /></Suspense>;
}
